module.exports = __webpack_public_path__ + "img/masks-pattern.c6fa9b15.jpg";